export const ROUTE_ABOUT = '/about'
export const ROUTE_ENTRENAMIENTO = '/entrenamiento'
export const ROUTE_GRADERIA_MORADA = '/graderia-morada'
export const ROUTE_HOME = '/'
export const ROUTE_MY_POSTS = '/my-posts'
export const ROUTE_TICKET = '/ticket/:userId/:teamName/:gameDate'
export const ROUTE_TO_PLAY = '/to-play'
export const ROUTE_TO_PLAY_VIEWER = '/to-play/:workshopId'
